import { useEffect } from "react";
import { mustGetElementById, mustQuerySelectorAtIndex } from "./helpers";
import { useProxyError } from "./useProxyError";
import { useProxyAction } from "./useProxyAction";

const getCountryCodeSelect = () => mustGetElementById<HTMLSelectElement>('countryCode');
const getNumberInput = () => mustGetElementById<HTMLInputElement>('number');
const getVerificationCodeInput = () => mustGetElementById<HTMLInputElement>('verificationCode');

const getSendCodeButton = () => mustGetElementById<HTMLButtonElement>('sendCode');
const getCallMeButton = () => mustGetElementById<HTMLButtonElement>('verifyPhone');
const getVerifyCodeButton = () => mustGetElementById<HTMLButtonElement>('verifyCode');
const getContinueButton = () => mustGetElementById<HTMLButtonElement>('continuePhone');
const getCancelButton = () => mustGetElementById<HTMLButtonElement>('cancel');
const getSendANewCodeAnchor = () => mustGetElementById<HTMLAnchorElement>('retryCode');

const getPageError = () => mustGetElementById('errorMessage');
const getPhoneNumberError = () => mustQuerySelectorAtIndex('.error.itemLevel', 1, 'phone number error');
const getVerificationCodeError = () => mustQuerySelectorAtIndex('.error.itemLevel', 2, 'verification code error');

export function usePhoneFactorSetupProxy({ phoneNumber, verificationCode } : {
  phoneNumber?: string
  verificationCode?: string
}) {
  // fields
  useEffect(() => {
    if (phoneNumber === undefined) return;
    const numberInput = getNumberInput();
    numberInput.setAttribute('pattern', '\\d{10}');
    numberInput.value = phoneNumber;
    numberInput.dispatchEvent(new KeyboardEvent('keyup'));
  }, [phoneNumber]);

  useEffect(() => {
    if (verificationCode === undefined) return;
    const verificationCodeInput = getVerificationCodeInput();
    verificationCodeInput.value = verificationCode;
    verificationCodeInput.dispatchEvent(new Event('input'));
  }, [verificationCode]);

  // actions
  const sendCodeAction = useProxyAction(getSendCodeButton);
  const callMeAction = useProxyAction(getCallMeButton);
  const verifyCodeAction = useProxyAction(getVerifyCodeButton);
  const continueAction = useProxyAction(getContinueButton);
  const cancelAction = useProxyAction(getCancelButton);
  const sendANewCodeAction = useProxyAction(getSendANewCodeAnchor);

  // errors
  const pageError = useProxyError(getPageError);
  const phoneNumberError = useProxyError(getPhoneNumberError);
  const verificationCodeError = useProxyError(getVerificationCodeError)

  useEffect(() => {
    const sel = getCountryCodeSelect();
    const opt = Array.from(sel.options).find(o => o.text === 'Canada (+1)');
    if (!opt) throw new Error("Canada is missing");
    opt.selected = true;
  }, []);

  return {
    sendCodeAction, callMeAction, verifyCodeAction, continueAction, cancelAction, sendANewCodeAction,
    pageError, phoneNumberError, verificationCodeError
  };
}
